import { INNRD } from '../../../helpers/helper';
import { DeleteData, GetOptData, UpdateData, IsNotNull, GetAllData, CreateData, GetData } from '../../../helpers/helper';

const createLeaveRequest = async (b) => {
  let result = { code: 'C-00', status: false, message: '' };
  let url = process.env.REACT_APP_API_URL + "leave-create";
  await CreateData(b, url).then(x => { result = x })
  return result;
}

const deleteLeaveRequest = async (b) => {
  let result = { code: 'D-00', status: false, message: '' };
  let url = process.env.REACT_APP_API_URL + "leave-delete";
  await DeleteData(b, url).then(x => { result = x })
  return result;
}

const approveLeaveRequest = async (b) => {
  let result = { code: 'U-00', status: false, message: '' };
  let url = process.env.REACT_APP_API_URL + "leave-approve";
  await UpdateData(b, url).then(x => { result = x })
  return result;
}

const rejectLeaveRequest = async (b) => {
  let result = { code: 'U-00', status: false, message: '' };
  let url = process.env.REACT_APP_API_URL + "leave-reject";
  await UpdateData(b, url).then(x => { result = x })
  return result;
}

const getLeaveForOptions = async () => {
  let result = null
  let url = process.env.REACT_APP_API_URL + "leaves-for-opt"
  await GetOptData(url).then(x => { result = IsNotNull(x) ? x : null })
  return result;
}

const getLeaveRequest = async (b) => {
  let result = null
  let url = process.env.REACT_APP_API_URL + "leave-get-data";
  await GetData(b, url).then(x => { result = INNRD(x, null) })
  return result;
}

const getLeaveRequestSummary = async (b) => {
  let result = null
  let url = process.env.REACT_APP_API_URL + "leave-get-summary";
  await GetData(b, url).then(x => { result = INNRD(x, null) })
  return result;
}

const getLeaveRequestHistoryLog = async (b) => {
  let result = null
  let url = process.env.REACT_APP_API_URL + "leave-get-hist-log";
  await GetData(b, url).then(x => { result = INNRD(x, null) })
  return result;
}

//getLeaveTypeForOptions
const getLeaveTypeForOptions = async () => {
  let result = null
  let url = process.env.REACT_APP_API_URL + "leave-get-type-opt"
  await GetOptData(url).then(x => { result = IsNotNull(x) ? x : null })
  return result;
}

export {
  getLeaveRequest,
  createLeaveRequest,
  deleteLeaveRequest,
  approveLeaveRequest,
  rejectLeaveRequest,
  getLeaveForOptions,
  getLeaveRequestSummary,
  getLeaveRequestHistoryLog,
  getLeaveTypeForOptions
  // getLeave,
}